import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useRef, useState } from 'react';
import { cn } from "../lib/cn.js";
import { Button } from "./button.js";
import { Label, Textarea } from "./input.js";
import { Dialog, DialogContent, DialogFooter } from "./overlay.js";
const TONE_VARIANT = {
    danger: 'danger',
    neutral: 'primary',
};
export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel, cancelLabel = 'Cancelar', tone = 'danger', onConfirm, reason, loading = false, }) => {
    const [reasonText, setReasonText] = useState('');
    const reasonId = useId();
    const reasonMissing = reason?.required === true && reasonText.trim() === '';
    /*
     * Um "Confirmar" por vez — F248. Quem passa uma promessa ganha a guarda sem
     * precisar do `loading`: o segundo clique, antes de a tela trocar, não manda
     * o cancelamento (ou a baixa) duas vezes.
     */
    const running = useRef(false);
    const handleConfirm = () => {
        if (loading || running.current)
            return;
        const result = onConfirm(reason === undefined ? undefined : reasonText);
        if (result instanceof Promise) {
            running.current = true;
            void result.finally(() => {
                running.current = false;
            });
        }
    };
    return (_jsx(Dialog, { open: open, onOpenChange: (next) => {
            if (!next)
                setReasonText('');
            onOpenChange(next);
        }, children: _jsxs(DialogContent, { title: title, children: [_jsx("p", { className: "text-(length:--text-sm) text-(--text-secondary)", children: description }), reason === undefined ? null : (_jsxs("div", { className: cn('mt-3 flex flex-col gap-1'), children: [_jsx(Label, { htmlFor: reasonId, required: reason.required ?? false, children: reason.label }), _jsx(Textarea, { id: reasonId, value: reasonText, placeholder: reason.placeholder, onChange: (event) => {
                                setReasonText(event.target.value);
                            } })] })), _jsxs(DialogFooter, { children: [_jsx(Button, { type: "button", variant: "secondary", disabled: loading, onClick: () => {
                                onOpenChange(false);
                            }, children: cancelLabel }), _jsx(Button, { type: "button", variant: TONE_VARIANT[tone], loading: loading, disabled: reasonMissing, onClick: handleConfirm, children: confirmLabel })] })] }) }));
};
//# sourceMappingURL=confirm-dialog.js.map